import styled from 'styled-components/macro';

//import theme helpers
import { getColor } from '../../../util/theme';

const StateContainer = styled.div`
  svg {
    fill: ${getColor('white')};

    max-width: 30px;
    max-height: 30px;
  }
`;

export default StateContainer;
